import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class PauseIcon extends AbstractIcon {
  static selector = "pause-icon"

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path d="M12,6H10A2,2,0,0,0,8,8V24a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"/>
        <path d="M22,6H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"/>
      </svg>`;
  }
}

componentsRegistryService.define(PauseIcon);